;(function () {
  const getDistanceToNext = (element, nextElement) => {
    if (element && nextElement) {
      return (nextElement.getBoundingClientRect().left - element.getBoundingClientRect().right);
    }
  }

  const getDistanceToPrev = (element, prevElement) => {
    if (element && prevElement) {
      return (prevElement.getBoundingClientRect().right - element.getBoundingClientRect().left);
    }
  }

  const footer = () => {
    const footerSections = document.querySelectorAll(".footer");

    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.contentRect.width >= 990) {
          const blockLogo = entry.target.querySelector(".footer-block--logo");
          const blockContacts = entry.target.querySelector(".footer-block--contacts");

          const calculatePaddingLeft = (element) => {
            if (element) {
              if (element.previousElementSibling?.classList.contains("footer-block--menu")) {
                const distance = getDistanceToPrev(element, element.previousElementSibling) / 2;
    
                element.style.setProperty("--border-left-distance", `${distance}px`);
              } else {
                element.style.setProperty("--border-left-distance", `-12px`);
                element.style.marginLeft = 0;
                if (entry.contentRect.width >= 1360) {
                  element.style.setProperty("--border-left-distance", `-32px`);
                }
              }
            }

            if (element && (!blockLogo || !blockContacts)) {
              element.style.setProperty("--border-left-distance", `-12px`);
              element.style.marginLeft = 0;
              if (entry.contentRect.width >= 1360) {
                element.style.setProperty("--border-left-distance", `-32px`);
              }
            }
          }

          const calculatePaddingRight = (element) => {
            if (element) {
              if (element.nextElementSibling?.nextElementSibling?.classList.contains("footer-block--menu")) {
                const distance = (-1 / 2) * getDistanceToNext(element, element.nextElementSibling?.nextElementSibling);
    
                element.style.setProperty("--border-right-distance", `${distance}px`);
              } else {
                element.style.setProperty("--border-right-distance", `-12px`);
                element.style.marginRight = 0;
                if (entry.contentRect.width >= 1360) {
                  element.style.setProperty("--border-right-distance", `-32px`);
                }
              }
            }

            if (element && (!blockLogo || !blockContacts)) {
              element.style.setProperty("--border-right-distance", `-12px`);
              element.style.marginRight = 0;
              if (entry.contentRect.width >= 1360) {
                element.style.setProperty("--border-right-distance", `-32px`);
              }
            }
          }

          calculatePaddingLeft(blockLogo);
          calculatePaddingRight(blockLogo);
          calculatePaddingLeft(blockContacts);
          calculatePaddingRight(blockContacts);
        }
      })
    })

    footerSections.forEach((section) => {
      resizeObserver.observe(section);
    })
  }






  // text reading functionality start
  document.addEventListener("DOMContentLoaded", function () {
    const paragraphs = document.querySelectorAll(".st-1-itm-description p");

    let allSpans = [];

    // STEP 1: Prepare ALL paragraphs (fade state)
    paragraphs.forEach((paragraph) => {
        const text = paragraph.innerText;
        paragraph.innerHTML = "";

        let spans = [];

        text.split("").forEach(letter => {
            const span = document.createElement("span");
            span.innerText = letter;
            paragraph.appendChild(span);
            spans.push(span);
        });

        allSpans.push(spans);
    });

    // STEP 2: Sequential animation
    let currentP = 0;
    const baseSpeed = 50; // change this for speed

    function animateParagraph() {
        if (currentP >= allSpans.length) return;

        let spans = allSpans[currentP];
        let index = 0;

        function animateLetter() {
            if (index < spans.length) {
                spans[index].classList.add("active");

                let char = spans[index].innerText;
                let delay = baseSpeed;

                // natural reading pauses
                if (char === " ") delay = baseSpeed + 40;
                if (char === "," || char === ".") delay = baseSpeed + 120;

                index++;
                setTimeout(animateLetter, delay);
            } else {
                currentP++;
                setTimeout(animateParagraph, 500); // gap between paragraphs
            }
        }

        animateLetter();
    }

    // STEP 3: Trigger when visible
    const section = document.querySelector(".st-1-itm-description");

    const observer = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) {
            animateParagraph();
            observer.disconnect();
        }
    });

    observer.observe(section);
  });
  // text reading functionality end





  document.addEventListener("DOMContentLoaded", function () {
        const paragraphs = document.querySelectorAll(".st-4-itm-cnt-description p");

        let allSpans = [];

        // STEP 1: Prepare ALL paragraphs
        paragraphs.forEach((paragraph) => {
            const text = paragraph.innerText;
            paragraph.innerHTML = "";

            let spans = [];

            text.split("").forEach(letter => {
                const span = document.createElement("span");
                span.innerText = letter;
                paragraph.appendChild(span);
                spans.push(span);
            });

            allSpans.push(spans);
        });

        // STEP 2: Sequential animation
        let currentP = 0;
        const baseSpeed = 10; // change this for speed

        function animateParagraph() {
            if (currentP >= allSpans.length) return;

            let spans = allSpans[currentP];
            let index = 0;

            function animateLetter() {
                if (index < spans.length) {
                    spans[index].classList.add("active");

                    let char = spans[index].innerText;
                    let delay = baseSpeed;

                    // natural reading pauses
                    if (char === " ") delay = baseSpeed + 40;
                    if (char === "," || char === ".") delay = baseSpeed + 120;

                    index++;
                    setTimeout(animateLetter, delay);
                } else {
                    currentP++;
                    setTimeout(animateParagraph, 500); // gap between paragraphs
                }
            }

            animateLetter();
        }

        // STEP 3: Trigger when visible
        const section = document.querySelector(".st-4-itm-cnt-description");

        const observer = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting) {
                animateParagraph();
                observer.disconnect();
            }
        });

        observer.observe(section);
    });

    




  document.addEventListener("shopify:section:load", footer)
  footer();
})()
